import { HoursArrayElement } from '@pages/reporting-pages/shipment-stops/types/HoursArrayElement';



interface TimelineHeaderProps {
	hoursArray: HoursArrayElement[] | undefined,
}


const TimelineHeader = (props: TimelineHeaderProps) => {
	const { hoursArray } = props;


	if (!hoursArray || hoursArray.length === 0) return (
		<div className='timeline-header'>
		</div>
	)

	return (
		<div className='timeline-headers'>
			{hoursArray && hoursArray.map((x, i) =>
				<div className={`timeline-header-block${x.isSelectedDate ? ' is-selected-date' : ''}`} key={`timeline-header-block-${x.hourNumber}-${i}`}>
					<p>{x.hourNumber}</p>
				</div>)}
		</div>
	)
}

export default TimelineHeader;